// components/TrainingLibrarySection.jsx
import { useState, useEffect, useRef } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
//import { DateTime } from "luxon";
import { toast } from "react-toastify";

export default function TrainingLibrarySection({
  db,
  storage,
  companyId,
  companyTimeZone,
  defaultThumbnailUrl,
  trainingCourses,
  setTrainingCourses,
}) {
  const [newCourse, setNewCourse] = useState({
    title: "",
    description: "",

    type: "video",
    url: "",
  });
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const uploadInputRef = useRef(null);

  useEffect(() => {
    const saved = localStorage.getItem("training_new_course_draft");
    if (saved) {
      try {
        setNewCourse(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse training_new_course_draft", e);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "training_new_course_draft",
      JSON.stringify(newCourse)
    );
  }, [newCourse]);

  const handleAddCourse = async () => {
    if (!newCourse.title || !newCourse.description) {
      toast.error("Please complete required fields.");
      return;
    }

    try {
      setUploading(true);
      let contentUrl = "";

      if (newCourse.type === "video" || newCourse.type === "pdf") {
        if (!uploadFile) {
          toast.error("Please upload a file.");
          setUploading(false);
          return;
        }

        const folder =
          newCourse.type === "video" ? "training_videos" : "training_pdfs";

        const fileRef = ref(storage, `${folder}/${uploadFile.name}`);
        await uploadBytes(fileRef, uploadFile);
        contentUrl = await getDownloadURL(fileRef);
      } else {
        if (!newCourse.url) {
          toast.error("Please enter a valid link.");
          setUploading(false);
          return;
        }
        contentUrl = newCourse.url;
      }

      // ✅ Always use one default thumbnail (no upload option)
      const thumbUrl = defaultThumbnailUrl;

      const data = {
        courseTitle: newCourse.title,
        description: newCourse.description,
        contentUrl,
        thumbnailUrl: thumbUrl,
        type: newCourse.type,
        assignedEmployees: [],

        createdAt: new Date().toISOString(),
      };

      const refDoc = await addDoc(
        collection(db, `companies/${companyId}/training_courses`),
        data
      );

      setTrainingCourses([...trainingCourses, { id: refDoc.id, ...data }]);

      setNewCourse({
        title: "",
        description: "",

        type: "video",
        url: "",
      });
      setUploadFile(null);

      if (uploadInputRef.current) uploadInputRef.current.value = "";

      localStorage.removeItem("training_new_course_draft");

      toast.success("Course added successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to add course.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="training-card">
      <h2>Add New Training Course</h2>

      <label>Course Type</label>
      <select
        value={newCourse.type}
        onChange={(e) => setNewCourse({ ...newCourse, type: e.target.value })}
        style={{ marginBottom: "1rem", padding: "0.5rem", width: "100%" }}
      >
        <option value="video">🎥 Video</option>
        <option value="pdf">📄 PDF</option>
        <option value="link">🔗 External Link</option>
      </select>

      <div className="coursedivcont">
        <div className="coursetitlediv">
          <label>Course Title</label>
          <input
            type="text"
            placeholder="Course Title"
            value={newCourse.title}
            onChange={(e) =>
              setNewCourse({ ...newCourse, title: e.target.value })
            }
          />
        </div>

        <div className="coursetitlediv">
          <label>Description</label>
          <input
            type="text"
            placeholder="Description"
            value={newCourse.description}
            onChange={(e) =>
              setNewCourse({ ...newCourse, description: e.target.value })
            }
          />
        </div>
      </div>

      {newCourse.type === "video" || newCourse.type === "pdf" ? (
        <>
          <label>
            {newCourse.type === "video" ? "Upload Video" : "Upload PDF"}
          </label>
          <input
            ref={uploadInputRef}
            type="file"
            accept={
              newCourse.type === "video" ? "video/mp4" : "application/pdf"
            }
            onChange={(e) => setUploadFile(e.target.files?.[0] || null)}
          />
        </>
      ) : (
        <>
          <label>External Course Link</label>
          <input
            type="url"
            placeholder="Paste external course link"
            value={newCourse.url}
            onChange={(e) =>
              setNewCourse({ ...newCourse, url: e.target.value })
            }
          />
        </>
      )}

      <button
        className="training-button"
        onClick={handleAddCourse}
        disabled={uploading}
      >
        {uploading ? "Uploading..." : "➕ Save Course"}
      </button>
    </div>
  );
}
